<template>
  <div class="lgn-page">
    <aside class="lgn-brand">
      <svg class="lgn-waves" viewBox="0 0 1440 320" preserveAspectRatio="none" aria-hidden="true">
        <path fill="rgba(255,255,255,0.07)"
          d="M0,224L48,208C96,192,192,160,288,170.7C384,181,480,235,576,234.7C672,235,768,181,864,160C960,139,1056,149,1152,176C1248,203,1344,245,1392,266.7L1440,288L1440,320L0,320Z" />
        <path fill="rgba(255,255,255,0.05)"
          d="M0,256L60,245.3C120,235,240,213,360,218.7C480,224,600,256,720,261.3C840,267,960,245,1080,224C1200,203,1320,181,1380,170.7L1440,160L1440,320L0,320Z" />
      </svg>

      <div class="lgn-brand-inner">
        <div class="lgn-brand-head">
          <div class="lgn-header-wrapper">
    <a class="lgn-logo" href="https://e-sea.kkp.go.id/perizinan">
      <img src="./assets/images/logo_new_v3.png" alt="logo" loading="lazy" />
    </a>

    <span class="lgn-org text-center" data-setting="app_name">
      DIREKTORAT PEMANFAATAN RUANG KOLOM PERAIRAN DAN DASAR LAUT
      <br />
      DIREKTORAT JENDERAL PENATAAN RUANG LAUT
    </span>
  </div>
        </div>

        <div class="lgn-hero">
          <div class="lgn-hero-card">
            <img class="lgn-hero-img" src="./assets/images/gambar.png" alt="logo-img" loading="lazy" />
          </div>
        </div>
      </div>
    </aside>

    <!-- ============ PANEL KANAN: FORM LOGIN ============ -->
    <section class="lgn-panel">
      <div class="lgn-card">
        <header class="lgn-head">
          <h1 class="lgn-title"><span class="lgn-accent">Sign</span> In</h1>
          <p class="lgn-sub">Selamat Datang di Halaman e-SEA</p>
        </header>

        <form class="lgn-form" novalidate @submit.prevent="checkIfRecaptchaVerified">
          <!-- Email -->
          <div class="lgn-field">
            <label class="lgn-label" for="email">Email</label>
            <div class="lgn-control">
              <svg class="lgn-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <rect x="3" y="5" width="18" height="14" rx="2" />
                <path d="m3 7 9 6 9-6" />
              </svg>
              <input type="text" v-model="form.username" class="lgn-input" :class="{ 'is-error': errors.has('Email') }"
                id="email" placeholder="Email" name="Email" v-validate="'required|email'" autocomplete="username"
                :aria-invalid="errors.has('Email') ? 'true' : 'false'" aria-describedby="email-error" />
            </div>
            <small class="lgn-error" id="email-error" role="alert" v-if="errors.has('Email')">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="9" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              {{ errors.first('Email') }}
            </small>
          </div>

          <!-- Password -->
          <div class="lgn-field">
            <label class="lgn-label" for="password">Password</label>
            <div class="lgn-control">
              <svg class="lgn-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <rect x="4" y="11" width="16" height="10" rx="2" />
                <path d="M8 11V8a4 4 0 0 1 8 0v3" />
              </svg>
              <input :type="showPassword ? 'text' : 'password'" v-model="form.password" class="lgn-input lgn-input--eye"
                :class="{ 'is-error': errors.has('Password') }" id="password" placeholder="Password" name="Password"
                v-validate="'required'" autocomplete="current-password"
                :aria-invalid="errors.has('Password') ? 'true' : 'false'" aria-describedby="password-error" />
              <button class="lgn-eye" type="button" id="btn-show" @click="toggleShow"
                :aria-label="showPassword ? 'Sembunyikan password' : 'Tampilkan password'"
                :aria-pressed="showPassword ? 'true' : 'false'">
                <svg v-if="showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                  <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                  <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </svg>
                <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </button>
            </div>
            <small class="lgn-error" id="password-error" role="alert" v-if="errors.has('Password')">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="9" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              {{ errors.first('Password') }}
            </small>
          </div>

          <!-- reCAPTCHA -->
          <div class="lgn-recaptcha">
            <VueRecaptcha @verify="markRecaptchaAsVerified" sitekey="6LcWcyopAAAAAMIHDH7BVEQuyt-Qw1T0C99UG6jz">
            </VueRecaptcha>
          </div>
          <p class="lgn-alert" role="alert" v-if="pleaseTickRecaptchaMessage">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" aria-hidden="true">
              <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
            <strong>{{ pleaseTickRecaptchaMessage }}</strong>
          </p>

          <!-- Tombol -->
          <button type="submit" class="lgn-btn lgn-btn--primary" :disabled="isLoading">
            <template v-if="!isLoading">Login</template>
            <Loader v-else />
          </button>

          <a class="lgn-btn lgn-btn--map"
            href="https://pprl.maps.arcgis.com/apps/webappviewer/index.html?id=895835c666b54fdcb3e272ca67773c30"
            target="_blank" rel="noopener noreferrer">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" aria-hidden="true">
              <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" />
              <line x1="8" y1="2" x2="8" y2="18" />
              <line x1="16" y1="6" x2="16" y2="22" />
            </svg>
            e-SEA MAP
          </a>

          <div class="lgn-links">
            <p class="lgn-links-row">
              <span>Anda belum memiliki Akun?</span>
              <a href="/register" class="lgn-link"> Buat Akun</a>
            </p>
            <p class="lgn-links-row">
              <a href="/lupa-password" class="lgn-link">
                Lupa password?
              </a>
            </p>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<style src="./assets/css/hope-ui.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/pro.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/custom.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/dark.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/customizer.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/rtl.min.css?v=2.0.0" lang="css" />
<!-- Gaya halaman login (desain baru). Kelas berawalan lgn- agar tidak bentrok dengan CSS tema di atas. -->
<style src="./Login.css" lang="css" scoped />
<!-- Library Bundle Script -->
<script src="./assets/js/core/libs.min.js"></script>
<!-- Plugin Scripts -->
<!-- <style src="./assets/css/custom/login-custom.css" lang="css" /> -->
<!-- Slider-tab Script -->
<script src="./assets/js/plugins/slider-tabs.js"></script>
<!-- Lodash Utility -->
<script src="./assets/vendor/lodash/lodash.min.js"></script>
<!-- Utilities Functions -->
<script src="./assets/js/iqonic-script/utility.js"></script>
<!-- Settings Script -->
<script src="./assets/js/iqonic-script/setting.js"></script>
<!-- Settings Init Script -->
<script src="./assets/js/setting-init.js"></script>
<!-- External Library Bundle Script -->
<script src="./assets/js/core/external.min.js"></script>
<!-- Widgetchart Script -->
<script src="./assets/js/charts/widgetcharts.js?v=2.0.0" defer></script>
<!-- Dashboard Script -->
<script src="./assets/js/charts/dashboard.js?v=2.0.0" defer></script>
<script src="./assets/js/charts/alternate-dashboard.js?v=2.0.0" defer></script>
<!-- Hopeui Script -->
<script src="./assets/js/hope-ui.js?v=2.0.0" defer></script>
<script src="./assets/js/hope-uipro.js?v=2.0.0" defer></script>
<script src="./assets/js/sidebar.js?v=2.0.0" defer></script>

<script>
import { VueRecaptcha } from 'vue-recaptcha'
import { Validator } from 'vee-validate'
import axios from 'axios'
import Swal from 'sweetalert2'
import Loader from '../../components/Loader/Loader'
import { encryptData, decryptData } from '../../helper/secureStorage';

export default {
  components: { VueRecaptcha, Loader },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      showPassword: false,
      form: {
        username: '',
        password: '',
      },
      recaptchaVerified: false,
      pleaseTickRecaptchaMessage: '',
      isLoading: false,
    }
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword
    },
    markRecaptchaAsVerified() {
      this.pleaseTickRecaptchaMessage = ''
      this.recaptchaVerified = true
    },
    async checkIfRecaptchaVerified() {
      await this.$validator.validateAll()
      if (this.$validator.errors.any()) return

      if (!this.recaptchaVerified) {
        this.pleaseTickRecaptchaMessage = 'Please tick recaptcha.'
        return true
      }
      this.login()
    },
    async login() {
      try {
        this.isLoading = true;
        
        // 1. Proses Sign In
        const res = await axios.post(
          `${this.baseapi}api/auth/signin`,
          this.form,
        );
        const user = res.data;
        
        if (!user || !user.data) {
          throw new Error('Respon login tidak valid');
        }

        const userData = user.data;

        // 2. Ambil Data Detail User (Nama UPT)
        const dataUser = await axios.get(
          `${this.baseapi}api/user/${userData.id}`,
          {
            headers: { Authorization: `Bearer ${userData.accessToken}` },
          },
        );

        userData.nama_upt = dataUser.data?.data?.nama_upt || '';

        // 3. Simpan ke LocalStorage dan pastikan synchronous selesai
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('token', userData.accessToken);
        
        if (userData.role !== 'pemohon') {
          localStorage.setItem('tokenCoofis', '442ed592-5f0f-4141-ad90-c1ea8e66af4a');
        }

        localStorage.setItem('login_time', Date.now().toString());

        // 4. FIX DELAY TOKEN: Berikan jeda mikrokosma / await tick agar localStorage 
        // benar-benar tertulis sebelum router berpindah (mencegah race condition di middleware)
        await this.$nextTick();
        
        // Alternatif tambahan: pastikan token benar-benar terbaca
        let tokenCheck = localStorage.getItem('token');
        while (!tokenCheck) {
          await new Promise(resolve => setTimeout(resolve, 50));
          tokenCheck = localStorage.getItem('token');
        }

        // 5. Redirect ke Dashboard
        await this.$router.push('/app/dashboard');

      } catch (error) {
        const status = error.response?.status;

        if (status && status >= 500) {
          Swal.fire('Error', 'Sedang terjadi kendala pada Server', 'error');
        } else {
          Swal.fire('Login Gagal', 'Username atau Password salah!', 'warning');
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
          email: () => 'Format email tidak sesuai',
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
  },
}
</script>